module.exports = __webpack_public_path__ + "img/questionBankTitle.9c30fb7e.svg";